 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		28: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"1":"vendors~lazy-imports~literatum-auth~literatum-commerce","2":"vendors~LOI~slideshow","5":"AdvancedSearch","6":"AxelPublicationContent","7":"LOI","8":"MathJax","9":"PromptBanner","10":"SectionsNavigation","11":"ShowRecommended","12":"TabsSwipe","13":"administrators","14":"article","18":"coverImage","19":"crossPublishersRecommendations","20":"customFile","21":"favorites","22":"hero","23":"holdings","24":"imagesLazyLoader","25":"institutionAffiliations","26":"lazy-imports","27":"literatum-commerce","29":"optimizer","30":"pastIssue","31":"popNotification","32":"preview","34":"profile","35":"quickSearchCitation","36":"refineSearch","37":"requestidlecallback-polyfill","38":"search","39":"shibboleth","40":"slideshow","41":"usageReports","42":"vendors~AdvancedSearch","43":"vendors~AxelPublicationContent","44":"vendors~LOI","45":"vendors~dynamic-imports","46":"vendors~lazy-imports","47":"vendors~literatum-auth","48":"vendors~literatum-commerce"}[chunkId]||chunkId) + "-" + {"0":"cedfd24272731d07b459","1":"dc7372d7b14f5229808f","2":"f705882b7ef9ecfcc4ee","3":"1f9bfac0c8376c26baf5","4":"fb88cbf0cbc7f83cd407","5":"21d99e65b486b1096217","6":"6d50cbbae933a2fd09c9","7":"f60b68269030ca99cba6","8":"fd4fd0d14057d00a4035","9":"13dd7cd82fdc9f80881c","10":"76e20e8dabfe93dc4bd8","11":"fd8faf9338ba4704cc87","12":"a2362ce39763ee73ff54","13":"bb6a6695fa9f36779677","14":"d2011eec700da007c604","18":"08e60e0bfc8aed3b47b6","19":"5adf1d7acab82d5d7925","20":"724e44d3b6b0145bbb88","21":"5335a36427b3bbe847ce","22":"32d733b72f41fccc821f","23":"6b2b12a219d955213a1c","24":"0b3a056a91fec20a1e43","25":"f058434a7e8f0644e5e7","26":"1fd60d9d6b613be9ea90","27":"5386d4d636dd531955c1","29":"435dccf08364c757817c","30":"01580174818d484d24c6","31":"6c73e84f160785c27dc3","32":"da1d053c51649e568f2b","34":"bfe25d4c1588b514c50a","35":"41ec19e5e92014b514b3","36":"3d69c1ab8145ee46d093","37":"1662a85160f7f9aa4ace","38":"af446ce029ef1a526b8f","39":"5d8b491cd165dfa03651","40":"cd2b1f85a0227c573710","41":"fcab2333d161f91cb17f","42":"7aa3ad3cd4539706ed60","43":"e5b2543e128d1a856605","44":"5ed761c5f2747db61a80","45":"678de2b45bcf04793ec6","46":"42be83646645fae2b61d","47":"937d11c60ae3ed165543","48":"8ff6e98810a6bf6915d2","49":"d9a93d280bd4a188d0cb","50":"7ba2bfbe536cb27cf119","51":"d48988d95fd9b215a350","52":"a0ebdc2b1e2ca0151957","53":"a502825c00d29e0ba87b","54":"68ff84d33347d9300565","55":"115fc058a56f4d0f27bf","56":"ba8655e9b8ad1ffe76dd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 104);
